import React from 'react';

const About = () =>{

	return(
		<div className="about_container">
			<h1 className="heading_sub color_primary">About</h1>
			<p className="about_text">GithubHunt provides github users, a simple way to access most starred repositories, most followed user, search for any user, and many more functionality.</p>
		</div>
	)

}

export default About;